import React from 'react';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import MotifIcon from '@ey/motif-react-wrapper/Icon';

const Wrapper = styled.section`
	display: flex;
	align-items: center;

	svg {
		margin-right: var(--px-5);
		vertical-align: middle;
	}
`;
function PageHeader(props) {
	return (
		<Wrapper classname="title">
			<MotifIcon
				name="card-icon"
				className="card-icon"
				iconFunction={props.iconName}
				size={24}
			/>
			<section className="motif-h3-default-regular">{props.moduleName}</section>
		</Wrapper>
	);
}

export default PageHeader;
